import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { BaseWorkSafeBcSubSection, IBaseWorkSafeBcSubSectionProps } from "../BaseWorkSafeBcSubSection";

interface IWorkSafeBcPayeeInformationSectionProps extends IBaseWorkSafeBcSubSectionProps {
    firstPhysicianContributor?: EmployeeUIModel;
}

class WorkSafeBcPayeeInformationSection extends BaseWorkSafeBcSubSection<IWorkSafeBcPayeeInformationSectionProps, never> {
    public componentDidMount(): void {
        if (this.props.firstPhysicianContributor) {
            this.props.mutateModelState(s => {
                const physician = this.props.firstPhysicianContributor;

                s.PayeeNumber = physician.Model.BillingAgencyNumber;
                s.PractitionerNumber = physician.Model.ProfessionalNumber;
                s.PractitionerName = physician.Name;
            });
        }
    }

    public render(): JSX.Element {
        const data = this.props.model;

        return (
            <div className="flex-grow-container subsection-border-top">
                <div className="row margin-sm-bottom">
                    {this.renderFields(
                        {
                            labelValueKey: "WorkSafeBc_PayeeNumberLabel",
                            value: data.PayeeNumber,
                            hasParentClassName: true,
                            className: "col-md-6"
                        },
                        <TextboxControl
                            id={`WorkSafeBc_PayeeNumber_${this.props.formId}`}
                            onChange={value => this.props.mutateModelState(s => s.PayeeNumber = value)}
                            value={data.PayeeNumber}
                            maxLength={5}
                        />
                    )}
                    {this.renderFields(
                        {
                            labelValueKey: "WorkSafeBc_PractitionerNumberLabel",
                            value: data.PractitionerNumber,
                            hasParentClassName: true,
                            className: "col-md-6"
                        },
                        <TextboxControl
                            id={`WorkSafeBc_PractitionerNumber_${this.props.formId}`}
                            onChange={value => this.props.mutateModelState(s => s.PractitionerNumber = value)}
                            value={data.PractitionerNumber}
                            maxLength={5}
                        />
                    )}
                </div>
                <div className="row">
                    {this.renderFields(
                        {
                            labelValueKey: "WorkSafeBc_PayeeNameLabel",
                            value: data.PayeeName,
                            hasParentClassName: true,
                            className: "col-md-6"
                        },
                        <TextboxControl
                            onChange={value => this.props.mutateModelState(s => s.PayeeName = value)}
                            value={data.PayeeName}
                            maxLength={55}
                        />
                    )}
                    {this.renderFields(
                        {
                            labelValueKey: "WorkSafeBc_PractitionerNameLabel",
                            value: data.PractitionerName,
                            hasParentClassName: true,
                            className: "col-md-6"
                        },
                        <TextboxControl
                            onChange={value => this.props.mutateModelState(s => s.PractitionerName = value)}
                            value={data.PractitionerName}
                            maxLength={55}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export { WorkSafeBcPayeeInformationSection };
